// Set Yönetimi kaydet çubuğu: sunucu hatası → satır/çekmece hatası (formül döngüsü yolu, formül
// kimliği, konum). Kırılım kodları (breakdown_member_move, calculation_group_incomplete …) DR5
// metnine çevrilir (lib/kpi-breakdown-copy).

import { KPI_BREAKDOWN_ERROR_CODES } from "@mahir/shared";
import { ApiError } from "../../api/client";
import type { FormulaServerError } from "../../components/kpi/FormulaEditor";
import { breakdownErrorText } from "../../lib/kpi-breakdown-copy";
import { formatCyclePath } from "../../lib/kpi-set-editor";

const BREAKDOWN_CODES: ReadonlySet<string> = new Set(KPI_BREAKDOWN_ERROR_CODES);

export function toServerError(err: unknown): FormulaServerError {
  if (err instanceof ApiError) {
    const d = (err.details ?? {}) as Record<string, unknown>;
    return {
      message: BREAKDOWN_CODES.has(err.code)
        ? breakdownErrorText(err.code, err.message)
        : err.message,
      cyclePath: err.code === "KPI_FORMULA_CYCLE" ? formatCyclePath(d.cycle) : null,
      formulaId: typeof d.formulaId === "string" ? d.formulaId : null,
      position: typeof d.position === "number" ? d.position : null,
    };
  }
  return { message: err instanceof Error ? err.message : "Kaydedilemedi" };
}
